/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { styled } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import axios from "axios";
import qs from "qs";
import { useLocation } from "react-router-dom";

import SelectIcon from "assets/svg/select";
import Selected from "assets/svg/selected";
import useStyles from "./style";
import Button from "components/button";
import { Flex, Text } from "@chakra-ui/react";

const Input = styled(InputBase)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(3),
  },
}));

const AddColleague = () => {
  //   const [addBy, setAddBy] = useState('username');
  const [user, setUser] = useState({});
  const [error, setError] = useState();
  const [params, setParams] = useState({});
  const [from, setFrom] = useState("");
  const [hours, setHours] = useState([]);
  const styles = useStyles();
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem("token");
    axios
      .get("https://api.personatalenta.id/user/current", {
        headers: {
          Authorization: `Bearer ${token ? token : ""}`,
          "Content-Type": "x-www-from-urlencode",
        },
      })
      .then((res) => {
        setUser(res.data.user);
      })
      .catch((err) => {
        if (
          err.response.data.message === "Unauthorized" ||
          err.response.data === "Unauthorized"
        ) {
          // navigate('/');
        }
      });
  }, []);

  useEffect(() => {
    let ignore = false;

    const openElement = () => {
      if (location.search && !ignore) {
        const item = location.search?.slice(1)?.split("?");
        const pairs = item[0]?.split("=");
        if (pairs[0] === "from") {
          setFrom(pairs[1]);
        }
      }
    };
    openElement();
  }, [location.hash]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    axios
      .get("https://api.personatalenta.id/time/hours", {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "x-www-from-urlencode",
        },
      })
      .then((res) => {
        setHours(res.data.data);
      })
      .catch((err) => {
        console.log("err: ", err);
      });
  }, []);

  const onChangeInput = (e) => {
    const tmpValue = {};
    // Handle Select event which might be different or same depending on MUI version
    // MUI Select event.target has name and value.
    // The previous code used id, but Select usually uses name.
    // Let's ensure we handle both or check how Select is implemented.
    // For MUI Select, we usually pass `name` prop.
    const key = e.target.id || e.target.name;
    if (key) {
      tmpValue[key] = e.target.value;
      setParams({ ...params, ...tmpValue });
    }
  };

  const handleSubmit = () => {
    if (!params.name || params.name.length < 6) {
      setError("Nama minimal 6 karakter");
      return;
    }

    if (params.birth_date) {
      const birthDate = new Date(params.birth_date);
      const minDate = new Date("1940-01-01");
      const maxDate = new Date("2040-12-31");
      if (birthDate < minDate || birthDate > maxDate) {
        setError("Tanggal lahir tidak valid (1940-2040)");
        return;
      }
    }
    const token = localStorage.getItem("token");
    axios
      .post(
        "https://api.personatalenta.id/colleague/add",
        qs.stringify({ ...params }),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(() => {
        if (from === "matching") {
          window.location.assign("/matching");
        } else {
          window.location.assign("/dashboard/friend-list");
        }
      })
      .catch((err) => {
        console.log("err: ", err);
        setError(err.response.data);
        // setError(err.response.data.message || err.response.data)
      });
  };

  const todayLocalISO = new Date(
    Date.now() - new Date().getTimezoneOffset() * 60000
  )
    .toISOString()
    .split("T")[0];

  return (
    <div className={styles.app}>
      <div className={styles.services}>
        <div className={styles.servicesContainer}>
          <div className={styles.containerContent}>
            <div className={styles.rightContainer}>
              <h3 style={{ fontSize: 24 }}>Input data teman secara manual</h3>
              {error && (
                <Flex bgColor="red" pt={2} pb={2} pl={5} pr={5} width="100%">
                  <Text color="white">{error}</Text>
                </Flex>
              )}
              <div className={styles.containerSectionServices}>
                <div className="add-friend">
                  <h6 className="label">Display Name</h6>
                  <FormControl
                    variant="standard"
                    className={styles.formControl}
                  >
                    <Input
                      fullWidth
                      id="name"
                      className={styles.input}
                      type="text"
                      placeholder="Nama minimal 6 karakter"
                      inputProps={{ maxLength: 20 }}
                      onChange={onChangeInput}
                    />
                  </FormControl>
                </div>
                <div className="add-friend">
                  <h6 className="label">Tanggal Lahir Temanmu</h6>
                  <FormControl
                    variant="standard"
                    className={styles.formControl}
                  >
                    <Input
                      fullWidth
                      id="birth_date"
                      inputProps={{ min: "1940-01-01", max: "2040-12-31" }}
                      className={styles.input}
                      type="date"
                      placeholder="Tanggal Lahir"
                      onChange={onChangeInput}
                    />
                  </FormControl>
                </div>
                <div className="add-friend">
                  <h6 className="label">Jam Lahir</h6>
                  <FormControl
                    variant="standard"
                    className={styles.formControl}
                  >
                    <Select
                      fullWidth
                      id="birth_time"
                      name="birth_time"
                      value={params.birth_time || ""}
                      onChange={onChangeInput}
                      className={styles.input}
                      displayEmpty
                      input={<Input id="birth_time" />}
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: 300,
                          },
                        },
                      }}
                      renderValue={(selected) => {
                        if (!selected) {
                          return (
                            <span style={{ color: "#aaa" }}>Jam Lahir</span>
                          );
                        }
                        const selectedOption = hours.find(
                          (h) => h.value === selected
                        );
                        return selectedOption ? selectedOption.label : selected;
                      }}
                    >
                      <MenuItem disabled value="">
                        <em>Jam Lahir</em>
                      </MenuItem>
                      {hours.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
                <div className="add-friend">
                  <h6 className="label">Gender</h6>
                  <FormControl
                    variant="standard"
                    className={styles.formControlSmall}
                  >
                    <RadioGroup row id="gender" onChange={onChangeInput}>
                      <FormControlLabel
                        value={0}
                        control={
                          <Radio
                            id="gender"
                            icon={<SelectIcon />}
                            checkedIcon={<Selected />}
                          />
                        }
                        label="Pria"
                      />
                      <FormControlLabel
                        value={1}
                        control={
                          <Radio
                            id="gender"
                            icon={<SelectIcon />}
                            checkedIcon={<Selected />}
                          />
                        }
                        label="Wanita"
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
                <div className={styles.containerButton}>
                  {/* <Button variant="alternate" label="Cancel" /> */}
                  <Button
                    variant="primary"
                    label="Save"
                    onClick={() => handleSubmit()}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddColleague;
